// Storage-related constants (not user-facing text)
// Default company logo path in Firebase Storage
export const DEFAULT_COMPANY_LOGO_PATH = 'public/default_logo.png';

// Default company logo URL served by the app (no Firebase Storage request needed)
// Use a public asset to avoid Storage token URLs and extra paid requests.
export const DEFAULT_COMPANY_LOGO_URL = '/assets/logo/default_logo.png';


